import React from 'react';
import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { MdOutlineArrowBackIos } from 'react-icons/md';

interface PaginacaoProps {
  paginaAtual: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Paginacao: React.FC<PaginacaoProps> = ({ paginaAtual, totalPages, onPageChange }) => {
  const handleFirstPage = () => onPageChange(1);
  const handlePreviousPage = () => onPageChange(Math.max(paginaAtual - 1, 1));
  const handleNextPage = () => onPageChange(Math.min(paginaAtual + 1, totalPages));
  const handleLastPage = () => onPageChange(totalPages);

  return (
    <HStack spacing={4} justify="center" mt={4}>
      {totalPages > 1 && (
        <>
        <Button
        onClick={handleFirstPage}
        disabled={paginaAtual == 1}
        bgColor="transparent"
        size="sm"
      >
        <Icon as={MdOutlineArrowBackIos} fontSize="20px" />
      </Button>
      <Button
        onClick={handlePreviousPage}
        disabled={paginaAtual === 1}
        bgColor="transparent"
        size="sm"
      >
        <Icon as={MdOutlineArrowBackIos} fontSize="15px" />
      </Button>
      <Text fontSize="sm">
        Página {paginaAtual} de {totalPages} 
      </Text>
      <Button
        onClick={handleNextPage}
        disabled={paginaAtual === totalPages}
        bgColor="transparent"
        size="sm"
      >
        <Icon as={MdOutlineArrowBackIos} fontSize="15px" transform="rotate(180deg)" />
      </Button>
      <Button
        onClick={handleLastPage}
        disabled={paginaAtual === totalPages}
        bgColor="transparent"
        size="sm"
      >
        <Icon as={MdOutlineArrowBackIos} fontSize="20px" transform="rotate(180deg)" />
      </Button>
      </>
      )}
    </HStack>
  );
};

export default Paginacao;
